import { Box, Skeleton, Stack, useDeviceType } from '@packages/shared';
import { SampleOrderContent } from '../../components/SampleOrderContent';

export const SampleOrderSuspenseFallback = () => {
  const { isMobile } = useDeviceType();

  const stepperSkeleton = (
    <Stack direction="column" gap={6} pt={6} px={3}>
      <Stack direction="row" gap={2}>
        <Skeleton variant="circular" width={16} height={16} />
        <Skeleton variant="rectangular" width="60%" height={16} />
      </Stack>
      <Stack direction="row" gap={2}>
        <Skeleton variant="circular" width={16} height={16} />
        <Skeleton variant="rectangular" width="40%" height={16} />
      </Stack>
      <Stack direction="row" gap={2}>
        <Skeleton variant="circular" width={16} height={16} />
        <Skeleton variant="rectangular" width="45%" height={16} />
      </Stack>
    </Stack>
  );
  const stepperSkeletonMob = (
    <Stack direction="column" gap={2}>
      <Stack direction="row" justifyContent="space-between">
        <Skeleton variant="circular" width={24} height={24} />
        <Skeleton variant="circular" width={24} height={24} />
        <Skeleton variant="circular" width={24} height={24} />
      </Stack>
      <Skeleton variant="rectangular" width="100%" height={16} sx={{ mb: 4 }} />
    </Stack>
  );
  const pageContent = (
    <Stack direction="column" gap={2}>
      <Skeleton variant="rectangular" width="100%" height={160} />
      <Skeleton variant="rectangular" width="100%" height={160} />
      <Skeleton variant="rectangular" width="100%" height={160} />
    </Stack>
  );
  const actionBarContent = (
    <Stack direction="row" gap={1} justifyContent="flex-end" alignItems="center" width="100%">
      <Skeleton variant="rectangular" width="40%" height={16} />
      <Skeleton variant="rectangular" width="40%" height={24} />
    </Stack>
  );

  return (
    <Box sx={{ height: '100%', overflow: 'hidden', display: 'flex', width: '100%' }}>
      <Stack sx={{ overflow: 'hidden', flex: '1', flexDirection: 'row' }}>
        {!isMobile && (
          <Box sx={{ backgroundColor: 'common.white', flex: '0 0 30%' }}>{stepperSkeleton}</Box>
        )}

        <Stack sx={{ flexDirection: 'column', height: '100%', flex: isMobile ? '1' : '1 1 70%' }}>
          {isMobile && <Box sx={{ backgroundColor: 'common.white' }}>{stepperSkeletonMob}</Box>}

          <Box sx={{ flex: '1', height: '100%' }}>
            <SampleOrderContent pageContent={pageContent} actionBarContent={actionBarContent} />
          </Box>
        </Stack>
      </Stack>
    </Box>
  );
};
